import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import MyButton from '../../../utils/MyButton';
import { FaArrowCircleLeft } from "react-icons/fa";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Acciones que necesitas: obtén cliente, área e información de mantenimiento.
import { getCliente } from '../../../redux/actions/dataactions';
import { getMtoInfra,getArea } from '../../../redux/actions/infraactions';

import { PDFViewer } from '@react-pdf/renderer';
import './MtoInfraPDF.css';
import MtoInfraDocuPDF from './MtoInfraDocuPDF';

const MtoInfraPDF = ({ 
  getCliente,
  getMtoInfra,
  getArea,
  datainfra,
  data,
  match 
}) => {
  const [verPDF, setVerPDF] = useState(false);
  const history = useHistory();

  // Supongamos que en datainfra guardas: { mtoinfra, loadingmto, error } ...
  const { mtoinfra } = datainfra;

  // Si en data guardas { cliente, loading, ... }
  const { cliente } = data;

  useEffect(() => {
    // Obtenemos la info de Mantenimiento, pasándole areaId, clienteId, mtoId
    getMtoInfra(match.params.areaId, match.params.clienteId, match.params.mtoId);

    // Obtenemos la info del cliente (para la plantillaType)
    getCliente(match.params.clienteId);
    getArea(match.params.areaId,match.params.clienteId);
    // Si tuvieras acción para el área, la podrías llamar también
    // getArea(match.params.areaId);
  }, [
    getMtoInfra, 
    getCliente,
    getArea,
    match.params.areaId, 
    match.params.clienteId, 
    match.params.mtoId
  ]);

  const handleOpenPDF = () => {
    setVerPDF(!verPDF);
  };

  const goBack = () => {
    history.goBack();
  };

  // Función que renderiza el contenido central según el estado
  const renderContent = () => {
    // 1) Validar si NO hay plantillaType
    if (!cliente?.plantillaType) {
      return (
        <div className="mto-error-message">
          <p>
            Para ver el PDF, primero debe configurar el tipo de plantilla 
            (plantillaType) en la información del cliente.
          </p>
        </div>
      );
    }

    // 2) Si tenemos datos y se presiona "Ver PDF"
    //    asumiendo que en mtoinfra viene algo como: 
    //    { area: { ... }, cliente: { ... }, mto: { ... } }
    if (mtoinfra?.area && mtoinfra?.cliente && mtoinfra?.mto && verPDF) {
      return (
        <PDFViewer style={{ width: "100%", height: "90vh" }}>
          <MtoInfraDocuPDF
            area={mtoinfra.area}
            cliente={mtoinfra.cliente}
            mto={mtoinfra.mto}
          />
        </PDFViewer>
      );
    }

    return null;
  };

  return (
    <div className='div-inventaripdfgeneral'>
      <div className='div-inventaripdftitulo'>
        <div className="div_boton">
          <MyButton tip="Volver" onClick={goBack}>
            <FaArrowCircleLeft color="#03178C" className="icon-eliminarcliente" />
          </MyButton>
        </div>

        {/* 
          Solo mostramos el botón "Ver PDF" si el cliente tiene plantillaType. 
          De lo contrario, mostramos el mensaje de error en renderContent().
        */}
        {cliente?.plantillaType && (
          <Button 
            variant="text"
            color="primary"
            onClick={handleOpenPDF}
          >
            {verPDF ? "Ocultar PDF" : "Ver PDF"}
          </Button>
        )}
      </div>

      <div className='div-inventariopdfcontent'>
        {renderContent()}
      </div>
    </div>
  );
};

MtoInfraPDF.propTypes = {
  getCliente: PropTypes.func.isRequired,
  getArea:PropTypes.func.isRequired,
  getMtoInfra: PropTypes.func.isRequired,
  datainfra: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  datainfra: state.datainfra,
  data: state.data
});

export default connect(mapStateToProps, {
  getCliente,
  getMtoInfra,
  getArea
})(MtoInfraPDF);
